/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AffidavitEligibilityTemplate = {
    FrYoungCompany: 'FR_YOUNG_COMPANY',
    FrNoEmployee: 'FR_NO_EMPLOYEE',
    ChNoBusinessYet: 'CH_NO_BUSINESS_YET',
    EsActividadNoHabitual: 'ES_ACTIVIDAD_NO_HABITUAL'
} as const;
export type AffidavitEligibilityTemplate = typeof AffidavitEligibilityTemplate[keyof typeof AffidavitEligibilityTemplate];


export function instanceOfAffidavitEligibilityTemplate(value: any): boolean {
    for (const key in AffidavitEligibilityTemplate) {
        if (Object.prototype.hasOwnProperty.call(AffidavitEligibilityTemplate, key)) {
            // @ts-ignore
            if (AffidavitEligibilityTemplate[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AffidavitEligibilityTemplateFromJSON(json: any): AffidavitEligibilityTemplate {
    return AffidavitEligibilityTemplateFromJSONTyped(json, false);
}

export function AffidavitEligibilityTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffidavitEligibilityTemplate {
    return json as AffidavitEligibilityTemplate;
}

export function AffidavitEligibilityTemplateToJSON(value?: AffidavitEligibilityTemplate | null): any {
    return value as any;
}

